import { copyIcon, ilIcon2, tgIcon } from '../../../assets';
import QrCode from '../../../components/QrCode/QrCode';
import { useSelector } from 'react-redux';
import { TRootState } from '../../../store/store';
import { useTranslation } from 'react-i18next';
import { copyToClipboard } from '../../../utils/helper';
import { message } from 'antd';

const RefLink = () => {
    const refId = useSelector((state: TRootState) => state.user.value.info.account.refLinkId);
    const { t } = useTranslation();

    return (
        <>
            <div className="ref-link">
                <img
                    className="il rfl"
                    src={ilIcon2}
                    alt=""
                />

                <QrCode value={`https://t.me/TTM_partners_bot/TTM?startapp=r-${refId}`} />

                <p>{t('ref_link_t')}</p>
            </div>
            <div className="ref-link__btns">
                <button
                    className="ref-link__btns--btn share"
                    onClick={() => {
                        if (navigator.share) {
                            navigator
                                .share({
                                    text: `https://t.me/TTM_partners_bot/TTM?startapp=r-${refId}`,
                                })
                                .then(() => console.log('Successful share'))
                                .catch((error) => console.log('Error sharing:', error));
                        }
                    }}>
                    <img
                        src={tgIcon}
                        alt=""
                    />
                    {t('share')}
                </button>
                <button
                    className="ref-link__btns--btn copy"
                    onClick={async () => {
                        message.success(t('team.copy'));
                        await copyToClipboard(`https://t.me/TTM_partners_bot/TTM?startapp=r-${refId}`);
                    }}>
                    <img
                        src={copyIcon}
                        alt=""
                    />
                </button>
            </div>
        </>
    );
};

export default RefLink;
